import { render, staticRenderFns } from "./table.all-projects.vue?vue&type=template&id=b1670bca&scoped=true&"
import script from "./table.all-projects.vue?vue&type=script&lang=js&"
export * from "./table.all-projects.vue?vue&type=script&lang=js&"
import style0 from "./table.all-projects.vue?vue&type=style&index=0&id=b1670bca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1670bca",
  null
  
)

export default component.exports